import * as React from 'react';

var _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Svg401 = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 384"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M191.5 363.412c105.763 0 191.5-35.691 191.5-79.717 0-44.027-85.737-79.717-191.5-79.717S0 239.668 0 283.695c0 44.026 85.737 79.717 191.5 79.717Z",
  fill: "#E5DDF8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M327.671 181.767H281.38l.346-.198-7.807-38.125a2.947 2.947 0 0 0-2.888-2.351H138.698a2.923 2.923 0 0 1-1.613-.485l-16.941-11.094a2.925 2.925 0 0 0-1.613-.485H62.26a2.94 2.94 0 0 0-2.917 3.335l22.03 162.697a2.943 2.943 0 0 0 2.916 2.542h186.389l28.607.037a2.944 2.944 0 0 0 2.865-2.256l26.95-111.817c.228-.911-.479-1.8-1.429-1.8Z",
  fill: "#fff"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M327.671 179.563h-44.104l-7.49-36.56c-.486-2.38-2.615-4.114-5.053-4.114H138.698a.765.765 0 0 1-.406-.118l-16.94-11.094a5.147 5.147 0 0 0-2.828-.845H62.26a5.16 5.16 0 0 0-3.882 1.756 5.13 5.13 0 0 0-1.23 4.07l22.03 162.697c.346 2.542 2.54 4.452 5.111 4.452h186.389l28.607.037h.007a5.145 5.145 0 0 0 5.016-3.938l26.95-111.817a3.648 3.648 0 0 0-.685-3.13 3.68 3.68 0 0 0-2.902-1.396ZM82.404 286.222 61.53 132.07a.738.738 0 0 1 .73-.83h56.264c.147 0 .287.044.405.118l16.94 11.094c.84.551 1.819.845 2.829.845h132.333c.347 0 .649.25.722.588l7.307 35.678H104.92a2.214 2.214 0 0 0-2.173 1.785L82.404 286.222Zm217.603 8.663a.74.74 0 0 1-.715.566l-28.614-.037H85.122l21.625-111.435h219.996l-26.736 110.906Z",
  fill: "#442496"
})), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 120,
  y: 58,
  width: 191,
  height: 122
}, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M120 58h191v121.5H120V58Z",
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M257.693 201.693c23.953-23.954 25.303-61.952 4.049-87.488l-91.537 91.537c25.536 21.254 63.534 19.904 87.488-4.049Zm-81.448 3.665c23.832 17.085 57.205 14.92 78.619-6.494s23.579-54.787 6.495-78.619l-85.114 85.113Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M211 232c41.974 0 76-34.026 76-76s-34.026-76-76-76-76 34.026-76 76 34.026 76 76 76Zm42.257-126.281c-25.537-21.254-63.535-19.904-87.488 4.05-23.954 23.953-25.304 61.951-4.05 87.488l91.538-91.538Zm8.485 8.486c21.254 25.536 19.904 63.534-4.049 87.488-23.954 23.953-61.952 25.303-87.488 4.049l91.537-91.537Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.769 109.769c23.953-23.954 61.951-25.304 87.488-4.05l-91.538 91.538c-21.254-25.537-19.904-63.535 4.05-87.488Zm2.828 2.828c21.414-21.414 54.788-23.578 78.619-6.494l-85.113 85.113c-17.084-23.832-14.92-57.205 6.494-78.619Z",
  fill: "#442496"
}), /*#__PURE__*/React.createElement("path", {
  d: "M257.693 201.693c23.953-23.954 25.303-61.952 4.049-87.488l-91.537 91.537c25.536 21.254 63.534 19.904 87.488-4.049Zm-81.448 3.665c23.832 17.085 57.205 14.92 78.619-6.494s23.579-54.787 6.495-78.619l-85.114 85.113Z",
  fill: "#442496"
}), /*#__PURE__*/React.createElement("path", {
  d: "M211 236c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80Zm76-80c0 41.974-34.026 76-76 76s-76-34.026-76-76 34.026-76 76-76 76 34.026 76 76Z",
  fill: "#442496"
}))));

export { Svg401 as ReactComponent };
